import type SvgProps from '~/components/icons/svg-props'

export default function PlusIcon(props: SvgProps) {
  const { width = '24', height = '24', className = '', fill } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6977 9.2093C12.6977 8.82399 12.3853 8.51163 12 8.51163C11.6147 8.51163 11.3023 8.82399 11.3023 9.2093L11.3023 11.3023H9.2093C8.82399 11.3023 8.51163 11.6147 8.51163 12C8.51163 12.3853 8.82399 12.6977 9.2093 12.6977H11.3023V14.7907C11.3023 15.176 11.6147 15.4884 12 15.4884C12.3853 15.4884 12.6977 15.176 12.6977 14.7907L12.6977 12.6977H14.7907C15.176 12.6977 15.4884 12.3853 15.4884 12C15.4884 11.6147 15.176 11.3023 14.7907 11.3023H12.6977V9.2093Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM3.39535 12C3.39535 7.24778 7.24778 3.39535 12 3.39535C16.7522 3.39535 20.6047 7.24778 20.6047 12C20.6047 16.7522 16.7522 20.6047 12 20.6047C7.24778 20.6047 3.39535 16.7522 3.39535 12Z"
        fill={fill}
      />
    </svg>
  )
}
